export default [{
  header: 'Configuraciones',
  icon: 'PackageIcon',
  i18n: 'Configuraciones',
  items: [
    {
      url: null,
      name: 'Empresa',
      slug: 'settings',
      icon: 'FileIcon',
      permiso: '*', // TODO: set permission
      submenu: [
        {
          url: { name: 'users-management' },
          name: 'Adm. usuarios',
          icon: 'library_books',
          i18n: 'Documents',
          permiso: 'ED125'
        }
      ]
    },
    {
      url: null,
      name: 'Administración',
      slug: 'files',
      icon: 'SettingsIcon',
      permiso: 'ED158',
      submenu: [
        {
          url: { name: 'successful-bidders' },
          name: 'Adjudicatarios',
          icon: 'FileTextIcon',
          permiso: 'ED159'
        },
        {
          url: { name: 'manage-ware-houses' },
          name: 'Almacenes',
          icon: 'files',
          permiso: 'ED160',
        },
        {
          url: { name: 'manage-entities' },
          name: 'Entidades',
          icon: 'files',
          permiso: 'ED161',
        },
        {
          url: { name: 'manage-products' },
          name: 'Productos',
          icon: 'files',
          permiso: 'ED215'
        },
        {
          url: { name: 'settings-roles' },
          name: 'Roles',
          icon: 'library_books',
          permiso: 'ED237',
          i18n: 'States'
        },
        {
          url: { name: 'access-profiles' },
          name: 'Perfiles',
          icon: 'library_books',
          i18n: 'Documents',
          permiso: 'ED124'
        }
      ]
    },
  ]
}];
